<template>
  <div>
    <div class="p-5 bg-white rounded">   
      <div class="flex items-center justify-between my-3">
        <h3 class="black--text font-weight-bold">{{ $t('meter.digital_electricity_meter') }}</h3>
        <div class="flex align-center gap-2" style="max-width: 800px;">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="$helper.datelabel(startDate)"
                :placeholder="$t('date')"
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                :label="$t('from_date')"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              no-title
              locale="th"
              @input="menuStartDate = false"
              :header-date-format="$helper.headerDateFormat"
              :year-format="$helper.yearFormat"
              :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="$helper.datelabel(endDate)"
                :placeholder="$t('date')"
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                :label="$t('to_date')"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              no-title
              locale="th"
              @input="menuEndDate = false"
              :header-date-format="$helper.headerDateFormat"
              :year-format="$helper.yearFormat"
              :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
            ></v-date-picker>
          </v-menu>
          <v-btn class="primary" :disabled="isLoading" @click="initData();">
            <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
          </v-btn>
          <v-btn class="white--text mx-1"  color="#4285F4"
              @click="exportExcel()"
              :disabled="isLoading || isLoadingExportMeterLogs">
            <img src="@/assets/images/icon-excel.svg" alt="" width="20" class="me-2"> Export Excel
          </v-btn>
        </div>
      </div>

      <div class="container-overall-meter">
        <div class="box-overall">
          <div class="d-flex justify-between align-center">
            <div>
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('meter.sold_unit') }}</h5>
              <h3 class="darkwarning--text font-weight-bold mb-1">{{ $helper.toCurrency(logsOverAll.totalUnitSell) || currency}} {{ $t('meter.unit_kwh') }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
            <div>
              <img src="@/assets/images/meter-icon.png" alt="meter-icon" width="80">
            </div>
          </div>
        </div>

        <div class="box-overall">
          <div class="d-flex justify-between align-center">
            <div class="text-center">
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('payment.total_amount_sold') }}</h5>
              <h3 class="darkprimary--text font-weight-bold mb-1">{{ logsOverAll.totalCostSell | currencyPrefixSign }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
            <v-divider vertical></v-divider>
            <div class="text-center">
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('payment.average_price_per_unit') }}</h5>
              <h3 class="darkprimary--text font-weight-bold mb-1">{{ logsOverAll.totalCostAvg | currencyPrefixSign }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
          </div>
        </div>


        <div class="box-overall">
          <div class="d-flex justify-between align-center">
            <div class="text-center">
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('meter.meter_got_reset') }}</h5>
              <h3 class="info--text font-weight-bold mb-1">{{ $helper.toArabic(logsOverAll.totalResetMeter)}} {{ $t('by_time') }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
            <div>
              <img src="@/assets/images/meter-reset.png" alt="meter-icon" width="60">
            </div>
          </div>
        </div>

        <div class="box-overall">
          <div class="d-flex justify-between align-center">
            <div class="text-center">
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('meter.meter_got_turned_on') }}</h5>
              <h3 class="warning--text font-weight-bold mb-1">{{ $helper.toArabic(logsOverAll.totalTurnOn)}} {{ $t('by_time') }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
            <v-divider vertical></v-divider>
            <div class="text-center">
              <h5 class="mb-3 gray--text font-weight-regular">{{ $t('meter.meter_got_turned_off') }}</h5>
              <h3 class="error--text font-weight-bold mb-1">{{ $helper.toArabic(logsOverAll.totalTurnOff)}} {{ $t('by_time') }}</h3>
              <h6 class="gray--text font-weight-regular">{{$helper.dateTH(startDate)}} - {{ $helper.dateTH(endDate)}} </h6>
            </div>
          </div>
        </div>

      </div>
      <div >
        <v-data-table
          :headers="headers"
          :items="logsDataPrepare"
          :loading="isLoading"
          :items-per-page="20"
          class="border-2 data-table-resize-header"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')">

          <template v-slot:header.areaName="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
          </template>
          <template v-slot:header.meterName="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:190px">{{ header.text }}</div>
          </template>
          <template v-slot:header.customerName="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
          </template>
          <template v-slot:header.businessName="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
          </template>
          <template v-slot:header.createdBy="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
          </template>
          <template v-slot:header.note="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:100px">{{ header.text }}</div>
          </template>
       

          <template v-slot:body.prepend>
          <tr>
            <td class="text-center">
              <v-icon>mdi-filter-multiple-outline</v-icon>
            </td>
            <td class="ps-0">
              <v-menu
                v-model="menuCreatedAt"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="filterDateLabel(filterData.createdAt)"
                    :label="$t('payment.order_date')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    dense
                    hide-details
                    :append-icon="filterData.createdAt ? 'mdi-close' : null"
                    @click:append="filterData.createdAt = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterData.createdAt"
                  @input="menuCreatedAt = false"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  no-title
                  locale="th"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                ></v-date-picker>
              </v-menu>
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.areaName" type="text" :label="$t('area.area_name')" solo dense hide-details clearable />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.meterName" type="text" :label="$t('meter.meter_name')" solo dense hide-details clearable />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.customerName" type="text" :label="$t('customer.customer_name')" solo dense hide-details clearable />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.businessName" type="text" :label="$t('area.shop_name')" solo dense hide-details clearable />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.documentId" type="text" :label="$t('payment.order_number')" solo dense hide-details clearable />
            </td>
            <td>
              <v-select v-model="filterData.type" item-text="text" clearable
                item-value="value" multiple :items="filterOption.type" type="text" :label="$t('detail_list')" solo dense
                hide-details class="custom-select" :menu-props="{ bottom: true, offsetY: true}"
                content-class="custom-dropdown" :no-data-text="$t('noinfo')">
                <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="selectFilterDetailAll"
                    >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item @click="toggleItemDetail(item.value)">
                    <v-list-item-action class="me-1">
                      <v-checkbox
                        :value="filterData.type.includes(item.value)"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </td>
            <td class="ps-0">
              <v-currency-field v-model="filterData.unit" :label="$t('meter.number_of_units')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-currency-field v-model="filterData.oldUnit" :label="$t('meter.before_unit_do_list')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-currency-field v-model="filterData.newUnit" :label="$t('meter.after_unit_do_list')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-currency-field v-model="filterData.totalValue" :label="$t('payment.amount')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.createdBy" type="text" :label="$t('payment.name_of_person_do_list')" solo dense hide-details />
            </td>
            <td class="ps-0"></td>
          </tr>
         </template>

          <template v-slot:item.order="{ index }">
            <div  class="text-center">{{ index + 1 }}</div>
          </template>

          <template v-slot:item.meterName="{ item }">
            <div class="text-truncate">
              <div class="d-flex align-center">
                <div> {{ item.meterName}}</div>
                <div v-if="item.meterType == 'prepaid'" class="ms-2">
                  <v-chip class="chip-status info" >
                    <div class="chip-text-sm">{{ $t('prepaid') }}</div>
                  </v-chip>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:item.areaName="{ item }">
            <div class="text-truncate">{{item.areaName }}</div>
          </template>
          <template v-slot:item.customerName="{ item }">
            <div class="text-truncate">{{item.customerName }}</div>
          </template>
          <template v-slot:item.businessName="{ item }">
            <div class="text-truncate">{{item.businessName }}</div>
          </template>

          <template v-slot:item.documentId="{ item }">
            {{item.documentId }}
          </template>

          <template v-slot:item.type="{ item }">
            {{ statusType(item.type)}}
          </template>


          <template v-slot:item.unit="{ item }">
            <div class="text-right">
              <template v-if="item.type == 'add_balance' || item.type == 'reset_balance'">
                {{ $helper.toCurrency(item.unit) }}
              </template>
              <template v-else>
                -
              </template>
            </div>
            
          </template>

          <template v-slot:item.oldUnit="{ item }">
            <div class="text-right">
              <template v-if="item.type == 'add_balance' || item.type == 'reset_balance'">
                {{ $helper.toCurrency(item.oldUnit) }}
              </template>
              <template v-else>
                -
              </template>
            </div>
     
          </template>

          <template v-slot:item.newUnit="{ item }">
            <div class="text-right">
              <template v-if="item.type == 'add_balance' || item.type == 'reset_balance'">
                {{ $helper.toCurrency(item.newUnit) }}
              </template>
              <template v-else>
                -
              </template>
            </div>
          </template>


          <template v-slot:item.totalValue="{ item }">
            <div class="text-right">
              <template v-if="item.type == 'add_balance'">
                {{ item.totalValue | currencyPrefixSign }}
              </template>
              <template v-else>
                -
              </template>
            </div>
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ $moment(item.createdAt).format('DD/MM/YYYY, HH:mm')}} {{ $t('timeunit.minute.short') }}
          </template>

          <template v-slot:item.note="{ item }">
            <div class="text-truncate">{{ item.note }}</div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations ,mapActions} from "vuex";
import { Customer } from "../classes";
import { ExportMeterElecLogs } from "../exports";
export default {
  components: {
  },
  computed: {

  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isLoading: false,
      headers: [],
      menuStartDate: false,
      menuEndDate: false,
      startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      filterData : {
        areaName: null,
        businessName: null,
        customerName: null,
        meterName : null,
        documentId: null,
        type: [],
        unit: null,
        newUnit: null,
        oldUnit: null,
        totalValue: null,
        createdAt: null,
        createdBy: null,
      },
      filterOption: {
        type: [],
      },
      orderData: [],
      logsData: [],
      logsDataPrepare: [],
      logsOverAll : {
        totalUnitSell : 0,
        totalCostSell : 0,
        totalCostAvg : 0,
        totalResetMeter : 0,
        totalTurnOn : 0,
        totalTurnOff : 0,
      },
      isLoadingExportMeterLogs : false,
      menuCreatedAt: false,
    };
  },
  created() {
    this.headers = [
        {
          text: this.$t('rank'),
          align: "center",
          sortable: false,
          value: "order"
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap",
          value: "createdAt",
          text: this.$t('payment.order_date'),
          filter: (d) =>
            this.filterData.createdAt
              ? this.$moment(d).format('DD/MM/YYYY') == this.$moment(this.filterData.createdAt).format('DD/MM/YYYY')
              : true,
        },
        {
          text: this.$t('area.area_name'),
          align: "center whitespace-nowrap text-truncate hd-resize",
          class: "whitespace-nowrap",
          sortable: false,
          value: "areaName",
          filter: (d) => {
            if (this.filterData.areaName) {
              return d ? d.toLowerCase().includes(this.filterData.areaName.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          text: this.$t('meter.meter_name'),
          align: "center whitespace-nowrap text-truncate hd-resize meter-name",
          class: "whitespace-nowrap",
          sortable: false,
          value: "meterName",
          filter: (d) => {
            if (this.filterData.meterName) {
              return d ? d.toLowerCase().includes(this.filterData.meterName.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          text: this.$t('market.marchant_name'),
          align: "center whitespace-nowrap text-truncate hd-resize",
          class: "whitespace-nowrap",
          value: "customerName",
          sortable: false,
          filter: (d) => {
            if (this.filterData.customerName) {
              return d ? d.toLowerCase().includes(this.filterData.customerName.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          text: this.$t('bill.business_name'),
          align: "center whitespace-nowrap text-truncate hd-resize",
          class: "whitespace-nowrap",
          value: "businessName",
          sortable: false,
          filter: (d) => {
            if (this.filterData.businessName) {
              return d ? d.toLowerCase().includes(this.filterData.businessName.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap",
          value: "documentId",
          text: this.$t('payment.order_number'),
          filter: (d) => {
            if (this.filterData.documentId) {
              return d ? d.toLowerCase().includes(this.filterData.documentId.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap",
          value: "type",
          sortable: false,
          text: this.$t('detail_list'),
          filter: (d) => {
            if (this.filterData.type?.length) {
              return this.filterData.type.includes(d);
            }
            return true; 
          },
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap text-right",
          value: "unit",
          text: this.$t('meter.number_of_units'),
          filter: (d) => {
            if (this.filterData.unit) {
              return d ? d.toString().includes(this.filterData.unit) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap text-right",
          value: "oldUnit",
          text: this.$t('meter.before_unit_do_list'),
          filter: (d) => {
            if (this.filterData.oldUnit) {
              return d ? d.toString().includes(this.filterData.oldUnit) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap text-right",
          value: "newUnit",
          text: this.$t('meter.after_unit_do_list'),
          filter: (d) => {
            if (this.filterData.newUnit) {
              return d ? d.toString().includes(this.filterData.newUnit) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap",
          class: "whitespace-nowrap text-right",
          value: "totalValue",
          text: this.$t('payment.amount'),
          filter: (d) => {
            if (this.filterData.totalValue) {
              return d ? d.toString().includes(this.filterData.totalValue) : false;
            }
            return true;
          }
        },
        {
          align: "center whitespace-nowrap text-truncate hd-resize",
          class: "whitespace-nowrap",
          value: "createdBy",
          text: this.$t('payment.name_of_person_do_list'),
          sortable: false,
          filter: (d) => {
            if (this.filterData.createdBy) {
              return d ? d.toLowerCase().includes(this.filterData.createdBy.toLowerCase()) : false;
            }
            return true;
          }
        },
        {
          text: this.$t('note'),
          align: "center whitespace-nowrap text-truncate hd-resize",
          class: "whitespace-nowrap",
          sortable: false,
          value: "note"
        }
    ];

    this.filterOption.type = [
          { text: this.$t('turn_on_electricity'), value: 'turn_on' },
          { text: this.$t('turn_off_electricity'), value: 'turn_off' },
          { text: this.$t('meter.buy_unit_meter'), value: "add_balance" },
          { text: this.$t('meter.reset_meter'), value: "reset_balance" },
    ];
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions({
      getMeterDigitalLogs : 'digitalMeterLog/getDigitalMeterLogBetweenDateByMarket'
    }),
    async initData(){
      this.isLoading = true
      try{
        this.logsData = await this.getMeterDigitalLogs({
          marketId : this.marketId,
          startDate : this.$moment(this.startDate).startOf('day').format("YYYY-MM-DD"),
          endDate : this.$moment(this.endDate).endOf('day').format("YYYY-MM-DD")
        });
        this.logsDataPrepare = this.prepareDataLogs();
        this.isLoading = false
      }catch(err){
        this.isLoading = false
        this.$toast.show({
          content: err.message,
          color: "error"
        })
      }
    },
    prepareDataLogs(){
      let obj = [];
      let sumTotalValue = 0;
      let sumTotalUnit = 0;
      let countResetMeter = 0;
      let countTurnOnMeter = 0;
      let countTurnOffMeter = 0;
      if(this.logsData){
        this.logsData.forEach(item => { 
          let totalValue =  null;
          let totalUnit = null;
          let businessName = null;
          let customerName = null;
          let documentId = '-';
          let meterName = null;
          let areaName = null;
          if(item.booking && item.contract || item.booking && !item.contract){
            businessName = item.booking.businessName;
            customerName = Customer.getFullNameByCustomer(item.booking.customer);
          }else if(item.contract){
            businessName = item.contract.businessName;
            customerName = Customer.getFullNameByCustomer(item.contract.customer);
          }
          if(item.order){
            totalValue = item.order.totalValue
            totalUnit = item.order.totalUnit
            documentId = item.order.documentId
          }
          if(item.meter){
            areaName = item.meter.area.name;
            if(item.meter.isMain){
              meterName = this.$t('meter.main_meter')
            }else{
              meterName = item.meter.name ? item.meter.name : this,$t('meter.sub_meter')
            }
          }

          if(item.type == 'reset_balance'){
            countResetMeter++;
          }else if(item.type == 'turn_on'){
            countTurnOnMeter++;
          }else if(item.type == 'turn_off'){
            countTurnOffMeter++;
          }

          sumTotalValue += totalValue;
          sumTotalUnit += totalUnit;

          let data = {
            areaName : areaName,
            meterName : meterName,
            customerName : customerName,
            businessName : businessName,
            documentId : documentId,
            unit: item.type == 'add_balance' || item.type == 'reset_balance' ? item.unit : null,
            oldUnit: item.type == 'add_balance' || item.type == 'reset_balance' ? item.oldUnit : null,
            newUnit: item.type == 'add_balance' || item.type == 'reset_balance' ? item.newUnit : null,
            totalValue: item.type == 'add_balance' && item.order ? item.order.totalValue : null,
            typeText : this.statusType(item.type),
            type : item.type,
            note : item.note ? item.note : '-',
            createdAt : item.createdAt,
            createdBy : item.createdBy.firstName + ' ' + item.createdBy.lastName,
            meterType : item.meter && item.meter.digitalMeterData ? item.meter.digitalMeterData.type : null
          };
          obj.push(data);
        });
      }

      this.logsOverAll.totalUnitSell = sumTotalUnit || 0;
      this.logsOverAll.totalCostSell = sumTotalValue || 0;
      this.logsOverAll.totalCostAvg = sumTotalUnit ? sumTotalValue / sumTotalUnit : 0;
      this.logsOverAll.totalResetMeter = countResetMeter;
      this.logsOverAll.totalTurnOn = countTurnOnMeter;
      this.logsOverAll.totalTurnOff = countTurnOffMeter;

      return obj;
    },
    statusType(type){
      if(type == "reset_balance"){
        return this.$t('meter.reset_meter')
      }else if(type == "add_balance"){
        return this.$t('meter.buy_unit_meter')
      }else if(type == "turn_on"){
        return this.$t('turn_on_electricity')
      }else if(type == "turn_off"){
        return this.$t('turn_off_electricity')
      }
    },
    selectFilterDetailAll () {
      if (this.filterData.type?.length === this.filterOption.type.length) {
        this.filterData.type = []; 
      } else {
        this.filterData.type = this.filterOption.type.map(item => item.value);
      }
    },
    toggleItemDetail(item) {
      const index = this.filterData.type.indexOf(item);
      if (index > -1) {
        this.filterData.type.splice(index, 1);
      } else {
        this.filterData.type.push(item);
      }
    },
    exportExcel() {
      this.isLoadingExportMeterLogs = true;
      try {
        ExportMeterElecLogs.exportLogs(this.logsDataPrepare,this.startDate,this.endDate);
        this.isLoadingExportMeterLogs = false;
      } catch (err) {
        this.isLoadingExportMeterLogs = false;
        this.isError = true;
      }
    },
    filterDateLabel(date){
      if (date) {
        return this.$moment(date).format('DD MMM YYYY')
      } else {
        return ""
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.custom-dropdown .v-list-item__action{
  margin: 0 !important; 
  padding: 0; 
}
.container-overall-meter{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 15px;
  margin-bottom: 30px;
  .box-overall{
    background-color: var(--v-light-base);
    box-shadow: 0px 12px 44px 0px #0000001F;
    padding: 20px 15px;
    border-radius: 10px;
  }
}

.data-table-resize-header::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

.data-table-resize-header::v-deep td.hd-resize {
  max-width: 100px;
  &.meter-name{
    max-width: 190px; 
  }
}

</style>

<style>
.v-list-item__action{
  margin: 0 10px 0 0;
}


</style>